
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"none","cx":"14","cy":"14","r":"12","stroke-width":"3","stroke":"currentColor","stroke-opacity":".2"}}),_c('circle',{staticClass:"rotate",attrs:{"fill":"none","cx":"14","cy":"14","r":"12","stroke-width":"3","stroke":"currentColor","stroke-dasharray":"25, 100"}})])
          )
        }
      }
    